import { neutral, FontWeights, orange } from "@flat-ui";
import { Chip, SxProps, Typography } from "@mui/material";

interface Props {
  /** Option text to be displayed in the badge instead of Beta */
  text?: string;

  /** Optional style to pass */
  sx?: SxProps;
}

/**
 * @returns a red chips to indicate that the feature is in beta
 */
export function FaroBetaBadge({
  text = "BETA",
  sx,
}: Props): JSX.Element {
  return (
    <Chip
      label={
        <Typography
          sx={{
            color: neutral[0],
            /** Using pixel instead of rem units because the Badge is using it is set in pixel */
            fontSize: "10px",
            fontWeight: FontWeights.Bold,
            /** Using pixel instead of rem units because the Badge is using it is set in pixel */
            lineHeight: "12px",
          }}
        >
          {text}
        </Typography>
      }
      sx={{
        py: "2px",
        px: "4px",
        height: "unset",
        backgroundColor: orange[500],
        width: "fit-content",

        "& .MuiChip-label": {
          p: 0,
        },

        position: "relative",
        ...sx,
      }}
    />
  );
}
